import React, { useEffect, useRef, useState } from "react";
import {
  FaBars,
  FaChevronDown,
  FaChevronRight,
  FaCity
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/Logo.png";
import { Button, Modal, Offcanvas } from "react-bootstrap";
import '../../assets/css/Header.css';
import axios from "axios";
import BASE_URL from "../commanfile";
const TravelNavbar = ({ isScrolled, menus, tourSector }) => {
  const navigate = useNavigate();
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [showDrawer, setShowDrawer] = useState(false);
  const [mobileExpanded, setMobileExpanded] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mobileDropdown, setMobileDropdown] = useState(null);

  const toggleMobileDropdown = (menuName) => {
    setMobileDropdown(mobileDropdown === menuName ? null : menuName);
  };
  const handleMouseEnter = (section) => {
    if (window.innerWidth > 991) {
      setActiveDropdown(section);
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth > 991) {
      setActiveDropdown(null);
    }
  };

  const toggleDrawer = () => setShowDrawer((prev) => !prev);
  const closeDrawer = () => setShowDrawer(false);

  const toggleMobileExpand = (section) => {
    setMobileExpanded(mobileExpanded === section ? null : section);
  };

  const handleNavigation = (path) => {
    navigate(path);

    if (showDrawer) {
      closeDrawer();
    }
  };

  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const stickyHeaderStyle = {
    backgroundColor: isScrolled ? "green" : "red",
    boxShadow: isScrolled ? "0 2px 5px rgba(0,0,0,0.1)" : "none",
    transition: "background-color 0.3s ease, box-shadow 0.3s ease",
    position: "sticky",
    top: 0,
    zIndex: 9999,
    width: "100%",
    transition: "background-color 0.3s ease, box-shadow 0.3s ease",
  };
  console.log("test===>", tourSector)

  const handleSearch = async (text) => {
    if (!text.trim()) {
      setSearchResults([]);
      setShowSearchDropdown(false);
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(`${BASE_URL}api/toursearch`, {
        text,
      });

      if (res.data?.success) {
        setSearchResults(res.data.data || []);
        setShowSearchDropdown(true);
      }
    } catch (err) {
      console.error("Search failed:", err);
    } finally {
      setLoading(false);
    }
  };

  const searchTimeout = useRef(null);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      handleSearch(value);
    }, 400);
  };

  return (
    <div style={stickyHeaderStyle}>

      <div className="travel-navbar-container">
        <nav className="travel-navbar">
          <div className="navbar-logo">
            <div onClick={() => handleNavigation("/")} style={{ cursor: "pointer" }}>
              <img src={logo} alt="Logo" style={{
                width: "180px",
                height: "auto",
              }} />
            </div>
          </div>
          <div className="mobile-menu-icon" onClick={toggleDrawer}>
            <FaBars size={24} />
          </div>
          <div className="navbar-menu">
            {menus.map((menu) => (
              <div
                key={menu.id}
                className="menu-item"
                onMouseEnter={() => handleMouseEnter(menu.menuName)}
                onMouseLeave={handleMouseLeave}
              >
                <span style={{ textTransform: "uppercase" }}>{menu.menuName.toUpperCase()}</span>

                {activeDropdown === menu.menuName && (
                  <div className="dropdown-simple">
                    <h3 className="dropdown-heading">Do the Yatra your way</h3>

                    <ul className="dropdown-list">
                      {menu.tourDetails?.map((tour) => (
                        <li key={tour.id} className="dropdown-item"
                          onClick={() => navigate(`tour-details/${tour.type == "fit" ? `fit-${tour.id}` : tour.id}`)}
                        >
                          <div style={{
                            display: "flex",
                          }}>
                            <img
                              src={`${BASE_URL}/api/image?file=${encodeURIComponent(tour?.image?.substring(1))}`}
                              alt={tour.name}
                              style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                                marginRight: "8px",
                                verticalAlign: "middle",
                                marginTop: "7px"
                              }}
                            />
                            <div>

                              <div

                                style={{
                                  display: "inline-block",
                                  maxWidth: "280px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  verticalAlign: "middle",
                                  cursor: "pointer"
                                }}
                              >
                                {tour.name}
                              </div>
                              <div>

                                <span className="dropdown-item-desc"
                                  style={{
                                    display: "inline-block",
                                    maxWidth: "280px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    verticalAlign: "middle",
                                    padding: "5px 0",
                                    margin: "0px"
                                  }}
                                >{tour.description}</span>
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))}



            <div
              className="menu-item"
              onMouseEnter={() => handleMouseEnter("packages")}
              onMouseLeave={handleMouseLeave}
            >
              <span>CURATED PACKAGES</span>
              {activeDropdown === "packages" && (
                <div className="mega-dropdown">
                  <div className="dropdown-section">
                    {tourSector?.map((typeObj, typeIndex) => (
                      <div className="dropdown-column" key={`type-${typeIndex}`}>
                        <h3 className="dropdown-heading">{typeObj.type}</h3>
                        {typeObj.sector.map((sector, sectorIndex) => (
                          <div key={`sector-${sectorIndex}`}>
                            <ul className="dropdown-list">
                              {sector.tours.map((tour, tourIndex) => (
                                <li key={`tour-${tourIndex}`} className="dropdown-item"
                                  onClick={() =>
                                    navigate(`allpackeges/${sector.sectorId}`, {
                                      state: { tourSectorId: tour.tour_sector_id },
                                    })
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <div style={{
                                    display: "flex",
                                  }}>

                                    <img
                                      src={`${BASE_URL}/api/image?file=${encodeURIComponent(tour?.image?.substring(1))}`}
                                      alt={tour.name}
                                      style={{
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "50%",
                                        marginRight: "8px",
                                        verticalAlign: "middle",
                                        marginTop: "5px"
                                      }}
                                    />
                                    <div>

                                      <div

                                      >
                                        {tour.sector_name}
                                      </div>
                                      <span className="dropdown-item-desc"
                                        style={{
                                          display: "inline-block",
                                          maxWidth: "200px",
                                          wordWrap: "break-word",
                                          whiteSpace: "normal",
                                          lineHeight: "1.4",
                                          padding: "0px",
                                          marginLeft: "0px",
                                        }}
                                      >
                                        {tour.description || "What our travelers are saying"}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
                    ))}


                  </div>

                  <div className="dropdown-preview">
                    <div className="preview-image">
                      <img
                        src={`${BASE_URL}/api/image?file=${encodeURIComponent(tourSector?.[0]?.sector?.[0]?.tours?.[0]?.image?.substring(1))}`}


                        alt="Featured Package"
                        style={{ width: "100%" }}
                      />
                      <div className="preview-content">
                        <h4>Handpicked trips you'll love</h4>
                        <p>Explore our curated collection</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="menu-item">
              <div
                onClick={() => handleNavigation("/moments")}
                style={{ cursor: "pointer" }}
              >
                <span> OUR MOMENTS</span>
              </div>
            </div>
            <div className="menu-item">
              <div
                onClick={() => handleNavigation("/blog")}
                style={{ cursor: "pointer" }}
              >
                <span> OUR BLOGS</span>
              </div>
            </div>

            {/* <div className="menu-item">
              <div
                onClick={handleShow}

                style={{ cursor: "pointer" }}
              >
                <span>OUR HOTELS</span>
              </div>
            </div> */}

            <div className="menu-item">
              <div
                onClick={() => handleNavigation("/about-us")}
                style={{ cursor: "pointer" }}
              >
                <span>ABOUT US</span>
              </div>
            </div>
            <div className="menu-item">
              <div
                // onClick={() => window.location.href = process.env.PUBLIC_URL + "/contact-us"}
                onClick={() => handleNavigation("/contact-us")}
                style={{ cursor: "pointer" }}
              >
                <span>CONTACT US</span>
              </div>
            </div>
          </div>

          <div className="navbar-actions">

            <div className="navbar-actions" style={{ position: "relative" }}>
              <div className="search-wrapper">
                <input
                  type="text"
                  placeholder="Search tours..."
                  value={searchQuery}
                  onChange={handleSearchChange}
                  onFocus={() => searchResults?.length && setShowSearchDropdown(true)}
                  className="navbar-search-input"
                />

                {showSearchDropdown && (
                  <div className="search-results-dropdown">
                    {loading ? (
                      <div className="search-status">Searching...</div>
                    ) : searchResults?.length === 0 ? (
                      <div className="search-status">No results found</div>
                    ) : (
                      searchResults.map((item) => (
                        <div
                          key={`${item.source}-${item.id}`}
                          className="search-result-card"
                          onClick={() => {
                            const path = item.source === "tour" ? `/tour-details/${item.id}` : `/tour-details/fit-${item.id}`;
                            navigate(path);
                            setShowSearchDropdown(false);
                            setSearchQuery("");
                          }}
                        >
                          <div className="search-result-img">
                            <img
                              src={item.thumbnail ? `${BASE_URL}/api/image?file=${encodeURIComponent(item.thumbnail.substring(1))}` : "/placeholder.jpg"}
                              alt={item.name}
                            />
                          </div>
                          <div className="search-result-info">
                            <div className="search-result-name">{item.name}</div>
                            <div className="search-result-desc">
                              {item.itinerary.length > 0 && item.itinerary?.length} days {item.itinerary.length > 0 && item.itinerary.length - 1} nights
                            </div>
                          </div>

                        </div>
                      ))
                    )}
                  </div>
                )}
              </div>

            </div>

          </div>
        </nav>

        <Offcanvas
          show={showDrawer}
          onHide={closeDrawer}
          placement="start"
          className="mobile-drawer"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              <img src={logo} alt="Logo" style={{ height: "30px" }} />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <ul className="mobile-drawer-menu">
              {menus?.map((menu) => (
                <li key={menu.id}>

                  <div
                    className="mobile-menu-item"
                    onClick={() => toggleMobileExpand(menu.menuName)}
                  >
                    <span>{menu.menuName.toUpperCase()}</span>

                    {mobileExpanded === menu.menuName ? (
                      <FaChevronDown />
                    ) : (
                      <FaChevronRight />
                    )}
                  </div>

                  {mobileExpanded === menu.menuName && (
                    <div className="mobile-submenu">

                      <div className="mobile-type-block">

                        {menu.tourDetails?.map((tour) => (
                          <div
                            key={tour.id}
                            className="mobile-sector-block"
                            onClick={() =>{
                              navigate(
                                `tour-details/${tour.type === "fit" ? `fit-${tour.id}` : tour.id
                                }`
                              )
                                                            closeDrawer()}

                            }
                          >
                            <div className="d-flex">
                              <div style={{ width: "28px", height: "28px" }}>
                                <FaCity className="mobile-icon" />
                              </div>
                              <div className="mobile-sector-title d-flex align-items-center" >
                                <div>
                                  <div className="mobile-sector-title" style={{
                                    fontSize: "14px"
                                  }}>
                                    {tour.name}
                                  </div>


                                </div>

                              </div>
                            </div>

                          </div>
                        ))}

                      </div>

                    </div>
                  )}
                </li>
              ))}
              <li>
                <div
                  className="mobile-menu-item"
                  onClick={() => toggleMobileExpand("packages")}
                >
                  <span>CURATED PACKAGES</span>
                  {mobileExpanded === "packages" ? <FaChevronDown /> : <FaChevronRight />}
                </div>

                {mobileExpanded === "packages" && (
                  <div className="mobile-submenu">
                    {tourSector?.map((typeObj, typeIndex) => (
                      <div key={typeIndex} className="mobile-type-block">

                        <h4 className="mobile-type-heading">
                          {typeObj.type}
                        </h4>

                        {typeObj.sector.map((sector, sectorIndex) => (
                          <div key={sectorIndex} className="mobile-sector-block"
                          
                            onClick={() =>{

                              navigate(`allpackeges/${sector.sectorId}`, {
                                state: { tourSectorId: sector.tour_sector_id },
                              })
                              closeDrawer()
                            }
                                  }
                          >

                            <div className="mobile-sector-title">
                              <FaCity className="mobile-icon" />
                              {sector.sectorName}
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                )}
              </li>

              <li>
                <div
                  className="mobile-menu-item"
                  onClick={() => handleNavigation("/moments")}
                  style={{ cursor: "pointer" }}
                >
                  <span>OUR MOMENTS</span>
                </div>
              </li>

              <li>
                <div
                  className="mobile-menu-item"
                  onClick={() => handleNavigation("/blog")}
                  style={{ cursor: "pointer" }}
                >
                  <span>OUR BLOGS</span>
                </div>
              </li>

              <li>
                <div
                  className="mobile-menu-item"
                  onClick={() => handleNavigation("/about-us")}
                  style={{ cursor: "pointer" }}
                >
                  <span>ABOUT US</span>
                </div>
              </li>
              <li>
                <div
                  className="mobile-menu-item"
                  onClick={() => handleNavigation("/contact-us")}
                  style={{ cursor: "pointer" }}
                >
                  <span>CONTACT US</span>
                </div>
              </li>
            </ul>
          </Offcanvas.Body>
        </Offcanvas>
      </div>

      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Coming Soon</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          This feature is not available yet. Please check back later.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    </div>

  );
};

export default TravelNavbar;